import React from "react";
import moment from "moment";
import { Button, Popover, DateBox, SelectBox, TextBox } from "devextreme-react";
import { filterType } from "../../helpers/filterHelper";

class RangeFilter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.desdeRef = React.createRef();

    this.state = {
      open: false,
      desde: null,
      hasta: null,
      filtrarValid: true,
    };
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.selectedValues.length !== this.props.selectedValues.length
      && prevProps.selectedValues.length > this.props.selectedValues.length) {
      this.setState({
        desde: null, hasta: null, filtrarValid: true,
      });
    }
  }

  getnextyear = (current) => {
    const d = new Date(current);
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    const c = new Date(year + 1, month, day);

    return c;
  }

  getprevyear = (current) => {
    const d = new Date(current);
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    const c = new Date(year - 1, month, day);

    return c;
  }

  handleOpenClose = (open) => {
    this.setState({ open });
  }

  handleAccept = () => {
    const {
      desde,
      hasta,
    } = this.state;

    let filterValue;

    if (desde != null && hasta != null) {
      filterValue = {
        text: `${this.props.filterText}: ${this.state.desde.toLocaleDateString()} - ${this.state.hasta.toLocaleDateString()}`,
        value: {
          from: this.state.desde,
          to: this.state.hasta,
        },
      };
    }

    this.setState({
      open: false,
      desde: null,
      hasta: null,
    });
    this.props.onFilter([{
      column: this.props.column,
      type: filterType.date,
      value: filterValue,
    }]);
  }

  handleChangeDesde = (e) => {
    if (e.value !== null) {
      if (this.state.hasta) {
        if (moment(this.state.hasta).isSameOrAfter(e.value)) {
          if (moment(e.value).isBetween(this.getprevyear(this.state.hasta), this.state.hasta, null, [])) {
            this.setState({
              desde: e.value,
            });
          } else {
            this.setState((prevState) => ({
              desde: e.value,
              hasta: this.props.oneYearInterval ? this.getnextyear(e.value) : prevState.desde,
            }));
          }
        } else if (moment(this.state.hasta).isBefore(e.value)) {
          this.setState({
            desde: this.state.hasta,
          });
        }
      } else {
        this.setState({
          desde: e.value,
        });
      }

      if (this.state.desde && this.state.hasta) {
        if (this.state.desde > this.state.hasta) {
          this.setState({ filtrarValid: false });
        } else {
          this.setState({ filtrarValid: true });
        }
      }
    } else {
      this.setState({ desde: null });
    }
  }

  handleChangeHasta = (e) => {
    if (e.value !== null) {
      if (this.state.desde) {
        if (moment(this.state.desde).isSameOrBefore(e.value)) {
          if (moment(e.value).isBetween(this.state.desde, this.getnextyear(this.state.desde), null, [])) {
            this.setState({
              hasta: e.value,
            });
          } else {
            this.setState((prevState) => ({
              hasta: e.value,
              desde: this.props.oneYearInterval ? this.getprevyear(e.value) : prevState.desde,
            }));
          }
        } else if (moment(this.state.desde).isAfter(e.value)) {
          this.setState({
            hasta: this.state.desde,
          });
        }
      } else {
        this.setState({
          hasta: e.value,
        });
      }
      if (this.state.hasta && this.state.desde) {
        if (this.state.hasta < this.state.desde) {
          this.setState({ filtrarValid: false });
        } else {
          this.setState({ filtrarValid: true });
        }
      }
    } else {
      this.setState({ hasta: null });
    }
  }

  handleCancel = () => {
    this.setState({
      open: false, hasta: null, desde: null, filtrarValid: true,
    });
    this.handleAccept();
  }

  render() {
    return (
      <React.Fragment>
        <SelectBox
          onInitialized={(e) => {
            e.component.option("openOnFieldClick", false);
          }}
          displayExpr="Name"
          id={this.props.column}
          className="select-table-filter"
          fieldComponent={(props) => (
            <div className="select-table-filter-field" onClickCapture={() => this.handleOpenClose(!this.state.open)}>
              <span>{this.props.filterText}</span>
              <TextBox readOnly visible={false} />
              <i className="dx-icon dx-icon-filter"></i>
            </div>
          )}
        />
        <Popover
          onHiding={() => this.setState({ open: false })}
          closeOnOutsideClick
          visible={this.state.open}
          width={250}
          target={`#${this.props.column}`}
          position={{ offset: "0 16", my: "top" }}
          animation={{
            show: {
              type: "pop",
              duration: 0,
            },
          }}
        >
          <div id="desde" style={{ marginBottom: 5 }}>
            <span style={{ marginBottom: 5, fontWeight: "bold" }}>Fecha Desde:</span>
            <DateBox
              type="date"
              width={230}
              placeholder="día/mes/año"
              max={this.state.hasta || this.props.max}
              displayFormat="dd/MM/yyyy"
              showClearButton
              onValueChanged={this.handleChangeDesde}
              value={this.state.desde}
              invalidDateMessage="Fecha indicada no es valida"
              dateOutOfRangeMessage="La fecha indicada no puede ser mayor a hoy o a la fecha desde"
            />
          </div>
          <div id="hasta" style={{ marginTop: 10 }}>
            <span style={{ marginBottom: 5, fontWeight: "bold" }}>  Fecha Hasta:</span>
            <DateBox
              type="date"
              width={230}
              placeholder="día/mes/año"
              displayFormat="dd/MM/yyyy"
              showClearButton
              min={this.state.desde}
              max={this.props.max}
              onValueChanged={this.handleChangeHasta}
              value={this.state.hasta}
              dateOutOfRangeMessage="La fecha indicada no puede ser mayor a hoy o menor a la fecha desde"
              invalidDateMessage="Fecha indicada no es valida"
            />
          </div>
          <div style={{ marginTop: 10 }}>
            <Button text="Cerrar" onClick={this.handleCancel} />
            <Button
              text="Filtrar"
              className="filter-accept-button"
              disabled={!this.state.filtrarValid}
              onClick={this.handleAccept}
            />
          </div>
        </Popover>
      </React.Fragment>
    );
  }
}

export default RangeFilter;
